import { MarkdownArticle } from "@webapp/components/markdown-article";
import { YouTubeVideo } from "@webapp/components/youtube-video";
import { getDoc } from "@webapp/utils/content.server";
import { DOC_ICONS } from "@webapp/utils/doc-icons";
import { buildPageMeta } from "@webapp/utils/page-meta";
import { docStructuredData } from "@webapp/utils/structured-data";
import type { Route } from "./+types/docs.$slug";

export function loader({ params }: Route.LoaderArgs) {
  const doc = getDoc(params.slug);
  if (!doc) throw new Response("Not found", { status: 404 });
  return { doc };
}

export const meta: Route.MetaFunction = ({ data }) => {
  if (!data) return [{ title: "Docs · HypeStream" }];
  const { doc } = data;
  return [
    ...buildPageMeta({
      path: `/docs/${doc.slug}`,
      title: `${doc.frontmatter.title} · HypeStream Docs`,
      description: doc.frontmatter.description,
      type: "article",
    }),
    docStructuredData(doc),
  ];
};

export default function DocPage({ loaderData }: Route.ComponentProps) {
  const { doc } = loaderData;
  const Icon = DOC_ICONS[doc.frontmatter.icon];

  return (
    <article className="max-w-3xl">
      <div className="flex items-center gap-3">
        <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted">
          <Icon className="size-5" />
        </span>
        <h1 className="text-3xl font-semibold tracking-tight" data-testid="doc-title">
          {doc.frontmatter.title}
        </h1>
      </div>
      <p className="mt-3 text-lg text-muted-foreground">{doc.frontmatter.description}</p>
      {doc.frontmatter.video && (
        <YouTubeVideo videoKey={doc.frontmatter.video} placement="docs" className="mt-8" />
      )}
      <div className="mt-8">
        <MarkdownArticle markdown={doc.body} videoPlacement="docs" />
      </div>
    </article>
  );
}
